<template>
  <form-shell
    :title="$t('title')"
    :formsOnShell="formsOnShell"
    :successTexts="successTexts"
    :callbackRequest="createPhysicalWorldOrder"
    :makeBodyToRequest="makeBodyToRequest"
    @cancel="handleCancel"
  ></form-shell>
</template>
<script>
import { mapActions } from 'vuex'
import FormShell from '@/views/PhysicalWorld/components/FormShell.vue'
import PhysicalWorldManager from '../physical-world.manager'
import { TERMINAL_ROUTES_ENUM } from '../../../enums/physical-world.enum'
import {
  FORM_ADDRESS,
  FORM_RECEIVERS,
  FORM_OPEN_HOURS,
  FORM_OBSERVATION,
  FORM_ROLL_QUANTITY
} from './forms-context-terminals.enum'

export default {
  name: 'TerminalRollRequest',
  components: {
    FormShell
  },
  data () {
    return {
      formsOnShell: [
        FORM_ROLL_QUANTITY,
        FORM_RECEIVERS,
        FORM_ADDRESS,
        FORM_OBSERVATION,
        FORM_OPEN_HOURS
      ],
      successTexts: {
        title: this.$t('success.title'),
        info: this.$t('success.info'),
        content: this.$t('success.content')
      }
    }
  },
  methods: {
    ...mapActions({
      createPhysicalWorldOrder: 'CREATE_PHYSICAL_WORLD_ORDER'
    }),
    makeBodyToRequest () {
      return new PhysicalWorldManager().makeBodyToRequestTerminalRoll()
    },
    handleCancel () {
      this.$router.push({ name: TERMINAL_ROUTES_ENUM.TERMINALS })
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "title": "Solicitação de Bobina",
      "button": {
        "submit": "Solicitar"
      },
      "success": {
        "title": "Solicitação de bobina",
        "info": "Bobina solicitada com sucesso",
        "content": "Ao clicar no botão abaixo, você será encaminhado para listagem de ordens de serviço para acompanhar sua solicitação."
      }
    },
    "en-US": {
      "title": "Request Roll",
      "button": {
        "submit": "Request"
      },
      "success": {
        "title": "Request for roll",
        "info": "Roll requested successfully",
        "content": "By clicking the button below, you will be redirected to the service order list to track your request."
      }
    }
  }
</i18n>
